export var TIME_OUT = 1000;
export var TIME_OUT_INPUT = 500;
